import React, { useContext } from "react";
import { desktopContext } from "./context/desktopContext";
import Codex from "./project/Codex";
import Rcheckout from "./project/Rcheckout";
import Homegaurd from "./project/Homegaurd";
import Korner from "./project/Korner";

const ProjectView = () => {
  const cntxt = useContext(desktopContext);
  var element = <></>;
  // if
  switch (cntxt.app) {
    case "codex":
      element = <Codex />;
      break;
    case "rcheckout":
      element = <Rcheckout />;
      break;
    case "homegaurd":
      element = <Homegaurd />;
      break;
    case "korner":
      element = <Korner />;
      break;
    default:
      element = <p>Doesn't Exist</p>;
      break;
  }

  return (
    <>
      {element}
    </>
  );
};

export default ProjectView;
